/* eslint-disable no-unused-vars */
/* eslint-disable vars-on-top */
/* eslint-disable no-undef */
import * as Yup from 'yup';
import { useState, useEffect, useRef } from 'react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { paramCase } from 'change-case';
import { useForm } from 'react-hook-form';

import axios from 'axios';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { Link, Stack, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { PATH_AUTH, PATH_DASHBOARD } from '../../../routes/paths';
import useAuth from '../../../hooks/useAuth';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFTextField, RHFCheckbox } from '../../../components/hook-form';
import ErrorSpan from '../verify-code/ErrorSpan';
import '../register/register_style.css';

// ----------------------------------------------------------------------

export default function VerifyLogin() {
  const { loginone } = useAuth();
  const { radio } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const isMountedRef = useIsMountedRef();

  const [showPassword, setShowPassword] = useState(false);

  const [emailName, setEmailName] = useState('');
  const [passwordName, setPasswordName] = useState('');
  const loginIn = useRef(false);

  const [nameError, setNameError] = useState({
    emailError: null,
    passwordError: null,
  });

  const LoginSchema = Yup.object().shape({});

  const defaultValues = {
    email: '',
    password: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const EmailValue = window.localStorage.getItem('email_login');
  const accessToken = window.localStorage.getItem('accessToken');

  const userType = window.localStorage.getItem('user_type');
  console.log('userType111', userType);

  window.localStorage.setItem('verifylogin', 'verifylogin');

  useEffect(() => {
    enqueueSnackbar('Verify your registered profile');
  }, []);

  const onSubmit = async (data) => {
    const userid = window.localStorage.getItem('user_id');

    let error = {
      emailError: null,
      passwordError: null,
    };

    if (passwordName.trim().length === 0) {
      error = { ...error, passwordError: 'Password required' };
    }

    setNameError(error);
    if (error.emailError || error.passwordError) {
      return;
    }

    try {
      const result = await loginone(EmailValue, passwordName, radio);

      if (!result.success) {
        enqueueSnackbar(result.message.error, { variant: 'error' });
      } else {
        enqueueSnackbar('Login successful!', { variant: 'success' });

        if (result.status === 200) {
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_API_URL}/web_register/add-user-type`,
              {
                user_type: radio,
              },
              {
                headers: {
                  Authorization: `Bearer ${result.accessToken}`,
                  'x-access-token': result.accessToken,
                },
              }
            );
          } catch (error) {
            // enter your logic for when there is an error (ex. error toast)
          }
        }

        loginIn.current = true;

        setTimeout(() => {
          navigate(PATH_DASHBOARD.root);
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      reset();
      if (isMountedRef.current) {
        setError('afterSubmit', error);
      }
    }
  };
  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <RHFTextField type="email" name="email" label="Email address" value={EmailValue} />
        {nameError.emailError ? <ErrorSpan error={nameError.emailError} /> : null}

        <RHFTextField
          name="password"
          readOnly
          label="Password"
          type={showPassword ? 'text' : 'password'}
          value={passwordName}
          onChange={(e) => {
            setPasswordName(e.target.value);
            setNameError({ ...nameError, passwordError: '' });
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {nameError.passwordError ? <ErrorSpan error={nameError.passwordError} /> : null}
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        <RHFCheckbox name="remember" label="Remember me" />
        <Link component={RouterLink} variant="subtitle2" to={PATH_AUTH.resetPassword}>
          Forgot password?
        </Link>
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
        Login
      </LoadingButton>
    </FormProvider>
  );
}
